// src/components/Mapbox/MapControls.tsx
import React from "react";
import { FullscreenControl, NavigationControl, ScaleControl } from "react-map-gl";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconHome, IconPin, IconPinnedOff, IconPolygonOff, IconPolygon } from "@tabler/icons-react";
import GeocoderControl from "./GeocoderControl";
import { MAPBOX_TOKEN } from "../../constants/mapbox.constants";
import FilterPanel from "./FilterPanel";
import { LayerVisibility } from "../../types/mapbox.types";

interface MapControlsProps {
    isWardLabel: boolean;
    isPinned: boolean;
    zoomLevel: number;
    onWardLabelToggle: () => void;
    onPinToggle: () => void;
    onHomeClick: () => void;
    onFilterSet: (updates: Partial<LayerVisibility>) => void;
}

export const MapControls: React.FC<MapControlsProps> = ({
    isWardLabel,
    isPinned,
    zoomLevel,
    onWardLabelToggle,
    onPinToggle,
    onHomeClick,
    onFilterSet,
}) => {
    return (
        <>
            <GeocoderControl
                mapboxAccessToken={MAPBOX_TOKEN}
                position="top-left"
                bbox={[
                    144.91033993341807, -37.89729001675099, 145.0034423283179,
                    -37.82156692328041,
                ]}
                proximity={{
                    longitude: 144.956891130868,
                    latitude: -37.8594284700157,
                }}
            />
            <FilterPanel onChange={onFilterSet} />
            <FullscreenControl position="bottom-right" />
            <NavigationControl position="bottom-right" />
            <ScaleControl position="bottom-right" />
            <div className="action-button-group">
                <Tooltip
                    label={isWardLabel ? "Disable Ward" : "Enable Ward"}
                    position="top"
                    withArrow
                >
                    <ActionIcon
                        variant="filled"
                        color="#4a525e"
                        aria-label="Pin"
                        className="ward-label-button"
                        size="md"
                        onClick={onWardLabelToggle}
                    >
                        {!isWardLabel ? <IconPolygonOff stroke={1.5} /> : <IconPolygon stroke={1.5} />}
                    </ActionIcon>
                </Tooltip>
                <Tooltip
                    label={zoomLevel > 15 ? "Button disabled: Zoom level too high" : isPinned ? "Disable Pins" : "Enable Pins"}
                    position="top"
                    withArrow
                >
                    <ActionIcon
                        variant="filled"
                        color="#4a525e"
                        aria-label="Pin"
                        className="pin-button"
                        size="md"
                        onClick={onPinToggle}
                        disabled={zoomLevel > 15}
                    >
                        {!isPinned ? <IconPinnedOff stroke={1.5} /> : <IconPin stroke={1.5} />}
                    </ActionIcon>
                </Tooltip>
                <Tooltip label="Go to Home" position="top" withArrow>
                    <ActionIcon
                        variant="filled"
                        color="#4a525e"
                        aria-label="Home"
                        className="home-button"
                        size="md"
                        onClick={onHomeClick}
                    >
                        <IconHome stroke={1.5} />
                    </ActionIcon>
                </Tooltip>
            </div>
        </>
    );
};